import { statusOptions } from "data/globalData";
import {
	channelTypes,
	sizeTypeCol,
	styleColorBuyingAssocObj,
	colorBuyingQtyAssocObj,
	wearHouses,
} from "components/PimDashboard/DashboardComponents/Buying/BuyingSheet/data";

export const pimDashboardMeta = {
	name: "Pim",
	key: "pim",
	path: "pim",
};

export { channelTypes, wearHouses, sizeTypeCol, styleColorBuyingAssocObj, colorBuyingQtyAssocObj, statusOptions };

export const allPOItemAssoc = "fobPoItems";
export const poItemStyleAssoc = "styleData";
export const poItemColorAssoc = "colorData";

export const productionTypes = {
	FOB: { name: "FOB", key: "FOB" },
	LOCAL: { name: "Local", key: "LOCAL" },
	IMPORT: { name: "Import", key: "IMPORT" },
};

export const purchaseType = {
	LOCAL: { name: "Local", key: "LOCAL" },
	IMPORT: { name: "Import", key: "IMPORT" },
	FOB: { name: "FOB", key: "FOB" },
};

export const requisition_for = {
	order: { name: "Order", key: "order" },
	style: { name: "Style", key: "style" },
};

export const requisition_type = {
	local: { name: "Local", key: "local" },
	import: { name: "Import", key: "import" },
};

export const newBuyingStyleData = [];
